(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('player/question-abcd.html', '<div class=\"mobile-step mobile-step--abcd\">\n	<div class=\"step_header\">\n		<button class=\"btn btn--pin\" ng-click=\"stop()\"><span>{{quizid}}</span></button>\n		<h2 class=\"step_header_title\">{{ screen.title || \"Kies je antwoord\" }}</h2>\n	</div>\n	<div class=\"step_options grid-options grid-options--{{ screen.answers.length }}\">\n		<button\n          class=\"grid-option option--{{ game_config.answers[$index] }}\"\n          ng-click=\"chooseAnswer($index)\"\n          ng-repeat=\"answer in screen.answers\"\n          ng-class=\"{\'is-selected\': chosenAnswer === $index}\">\n			<span class=\"\"><b>{{ game_config.answers[$index] }}</b></span>\n		</button>\n\n	</div>\n\n</div>\n');
    }]);
})();